import { BridgeComponent } from '@hotwired/hotwire-native-bridge'
import { withIconSvg } from '../../utils/bridge_icons'

// Menu contextuel natif (UIAlertController .actionSheet) déclenché par un élément de
// page — ex. l'avatar du profil. `items` : [{ title, destructive, icon, click }] ;
// à la sélection, l'élément désigné par `click` est cliqué — la logique reste côté
// web (les mêmes boutons que le bottom sheet, qui sert de fallback web). `icon`
// (nom SF Symbol) sert à Android, qui reçoit aussi son dessin `svg` (utils/bridge_icons) ;
// iOS n'en affiche pas dans sa feuille.
// Le déclencheur peut être le lien du repli web : `present` annule sa navigation, et
// sans le composant côté app le controller ne se connecte pas, le lien reste actif.
export default class extends BridgeComponent {
  static component = 'action-sheet'
  static values = { title: String, items: Array }

  present(event) {
    event.preventDefault()
    const items = this.itemsValue.map(({ title, destructive, icon }) => withIconSvg({ title, destructive, icon }))
    this.send('present', { title: this.titleValue, items }, (message) => {
      const item = this.itemsValue[message.data.index]
      if (item?.click) document.querySelector(item.click)?.click()
    })
  }
}
